import React from "react";
// React Table
import { Container, Table, Row, Col } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaDescripcionProyecto = ({ datosMisionProyecto }) => {
  return (
    <Container>
      <Row>
        <Col>
          <Table bordered responsive>
            <tbody>
              <tr>
                <CustomTd className={"w-50"}>
                  <span>Numero de hermanas implicadas</span>
                </CustomTd>
                <td>{datosMisionProyecto?.nSister || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Numero de laicos implicados</span>
                </CustomTd>
                <td>{datosMisionProyecto?.nLay || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Numero de voluntarios</span>
                </CustomTd>
                <td>{datosMisionProyecto?.nVolunteer || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Objetivo</span>
                </CustomTd>
                <td>{datosMisionProyecto?.objective || <small>No especificado</small>}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
};

export default VistaDescripcionProyecto;
